<template>
  <div class="game-list-block" :class="{ 'addPaddingTop': isFixedGameTab }">
    <input class="search-block" :placeholder="$ln('搜尋遊戲')" v-model="searchKey"/>
    <div class="game-list-wrapper vld-parent">
      <transition name="fade">
        <!--        <div v-if="loading"></div>-->
        <LoadingAnimate
          v-if="loading"
          :is-loading="true"
          :is-full-page="false"
          bg-color="#0a1635"
          :bg-opacity="0"
        />
        <ul class="game-list" v-else-if="filterSearch.length > 0">
          <li v-for="(item, index) in filterSearch" :key="index" :class="{ 'refreshEffect': refreshStatus }" @click="openGame(item)">
            <img class="game-card" :src="`/icon/game/dragoonsoft_${item.gameId}_${translationLang(language)}.jpg`" alt="" />
            <img class="hot-tag" src="@/assets/img/icon/hot_tag.png" v-if="item.hot" alt=""/>
            <img class="new-tag" src="@/assets/img/icon/new_tag.png" v-if="item.latest" alt=""/>
          </li>
        </ul>
        <div v-else class="no-result-block">
          <img src="@/assets/img/icon/search_no_result.png" alt=""/>
          <span v-if="resultGameList.length > 0 ">{{ $ln('查無遊戲') }}</span>
          <span v-else>{{ $ln('未開啟遊戲權限') }}(1019)</span>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Base from '@/mixins/base'
import { openGameURL } from '@/service/api/game'
import { mapState } from 'vuex'
import LoadingAnimate from '@/components/layout/loadingAnimate'
import { isTgGame, isDemoLink, isNewGame, isMobile, isWindowOpen } from '@/plugins/isTypes'

export default {
  name: 'GameList',
  props: {
    isFixedGameTab: {
      type: Boolean,
      default() {
        return false
      }
    },
    // 分類後遊戲清單
    resultGameList: {
      type: [Array, Object],
      default() {
        return []
      }
    },
    // 刷新狀態
    refreshStatus: {
      type: Boolean,
      default() {
        return false
      }
    },
    // 遊戲清單載入狀態
    loading: {
      type: [String, Boolean],
      default() {
        return false
      }
    }
  },
  data() {
    return {
      urlQuery: [],
      searchKey: '',
    }
  },
  mixins: [
    Base
  ],
  computed: {
    ...mapState({
      language: state => state.app.language,
      identity: state => state.user.identity,
    }),
    filterSearch() {
      let filtered = []
      if (this.searchKey !== '') {
        let key = this.searchKey.toLocaleUpperCase()
        // console.log('this.searchKey !== empty')
        filtered = this.resultGameList.filter(function(item, index, array) {
          return item.gameNameList.filter(function(name, j, nameArray) {
            // console.log('name.toLocaleUpperCase().indexOf(key.toLocaleUpperCase()) !== -1', name.toLocaleUpperCase().indexOf(key.toLocaleUpperCase()) !== -1);
            return name.toLocaleUpperCase().indexOf(key.toLocaleUpperCase()) !== -1
          }).length > 0
        })
      } else {
        filtered = this.resultGameList
      }
      console.log('篩選的遊戲清單', filtered)
      return filtered
    },
    resultGameListCount() {
      return this.resultGameList.length;
    }
  },
  watch: {
    resultGameListCount(newVal) {
      if(newVal > 0) {
        console.log("陣列長度：", newVal);
        this.openNewGame()
      }

    }
  },
  components: {
    LoadingAnimate
  },
  created() {},
  async mounted() {


  },
  beforeDestroy() {},
  methods: {
    openNewGame() {
      if(!isNewGame()) return
      console.log(this.resultGameList)
      let isLatest = false
      this.resultGameList.forEach(item=>{
        if(!item.latest || isLatest) return
        isLatest = true
        console.log(item)
        this.openGame(item)
      })
    },
    /**
     * 進入遊戲
     */
    async openGame(item) {
      let urlStr = '';
      if(isDemoLink()) {
        urlStr = ` https://dsdemo.cc/${item.gameId}`
        navigator.clipboard.writeText(urlStr)
          .then(() => {
            alert(this.$ln('遊戲demo連結已複製'));
          })
          .catch(err => {
            console.log("copy err：", err);
          });
          return
      }
      const t = new Date().getTime() / 1000
      if (!this.checkPendding(t)) return
      // 遊戲網址會根據客戶網址不同
      let isDemo = this.identity !== '' && this.identity === 'guest'
      if (!isWindowOpen()) item = { ...item, backurl: `${window.location.href}` }
      // item = { ...item, backurl: `${window.location.href}` }
      console.log('open game item', item)
      const res = await openGameURL(item, this.language, isDemo)
      let url = ''
      if (res.code === 200 && res.result.result.code === 1) {
        url = res.result.url
        
        // 遊戲網址會根據客戶網址不同 進行替換
        const gameUrl = new URL(url)
        const apiHostname = process.env.VUE_APP_API || location.hostname
        
        // 取得網域後綴（去掉第一個子域名）
        const getDomainSuffix = (hostname) => {
          const parts = hostname.split('.')
          return parts.length > 2 ? parts.slice(1).join('.') : hostname
        }
        
        const targetDomain = getDomainSuffix(apiHostname)
        const gameDomainSuffix = getDomainSuffix(gameUrl.hostname)
        
        // 替換 hostname
        gameUrl.hostname = gameUrl.hostname.replace(gameDomainSuffix, targetDomain)
        
        // 重新構建 URL（oper 替換成目前登入使用的oper，後端送來的有時候會異常）
        urlStr = gameUrl.toString()
        
        if (!isWindowOpen()) {
          // 瀏覽器不支援另開視窗時帶入網址
          history.pushState(null, null, document.URL)
          window.location.href = urlStr
        } else {
          const windowPage = window.open(urlStr, '_new')
          // console.log('windowPage', `${urlObject.origin}${urlObject.pathname}?${urlParams.toString()}`)
          this.$emit('windowPage', windowPage)
        }
      } else {
        this.$message({
          message: `${res.result.result.msg}` + ` (${res.result.result.code})`,
          type: 'error'
        })
      }
      setTimeout(() => {
        this.removePendding(t)
      }, 3000)
    },
    /**
     * 請求時候,如果有前一個在等待則不可再次發送
     *
     */
    checkPendding(t) {
      if (this.urlQuery.length === 0) {
        this.urlQuery = [t]
        return true
      }
      const prevTime = this.urlQuery[this.urlQuery.length - 1]
      // 上一個請求超過n秒才可以再打
      if (t - prevTime < 5) return false
      this.urlQuery = [t]
      return true
    },
    removePendding(t) {
      const i = this.urlQuery.indexOf(t)
      if (i === -1) return
      this.urlQuery.splice(i, 1)
    },
  }
}
</script>
<style lang="scss" src="@/assets/css/app.scss"></style>
